import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Theme, styled } from '@material-ui/core';
import { useI18nPath } from '../../../config/clientRoutes/hooks';
import { LinkDivider } from '../../shared/components/publicPage/Atoms';
import packageJson from './../../../../package.json';

const StyledFooter = styled('footer')<Theme>(({ theme }) => ({
  marginTop: 'auto',
  padding: theme.spacing(2, 6),
  width: '100%',
  textAlign: 'center',
  fontSize: theme.typography.body2.fontSize,
  lineHeight: theme.typography.body2.lineHeight,
  borderTop: `0.1rem solid ${theme.palette.grey['200']}`,
}));

const trimPhoneNumber = (phone: string): string =>
  phone.replace('(', '').replace(')', '').replace(/\s/g, '');

const PublicPageFooter: FC = () => {
  const { t } = useTranslation();
  const { getPath } = useI18nPath();

  return (
    <StyledFooter>
      <div>{`${t('footer.copyright')} - ${t('footer.address')}`}</div>
      <div>
        <Link href={getPath('termsOfUse')} title={t('footer.termsOfUse')}>
          {t('footer.termsOfUse')}
        </Link>
        <LinkDivider>-</LinkDivider>
        <Link href={getPath('privacyPolicy')} title={t('footer.privacy')}>
          {t('footer.privacy')}
        </Link>
        <LinkDivider>-</LinkDivider>
        <Link href={`tel:${trimPhoneNumber(t('footer.phone'))}`}>{t('footer.phone')}</Link>
      </div>
      <div>v{packageJson.version}</div>
    </StyledFooter>
  );
};

export default PublicPageFooter;
